import React, { useEffect } from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation
} from "react-router-dom";

import PageTemplate from "./PageTemplate.js";
import Home from "./Home.js";
import About from "./About.js";
import Services from "./Services.js";
import Contact from "./Contact.js";
import Guides from "./Guides.js";
import Lawyers from "./Lawyers.js";
import L500Lawyers from "./L500Lawyers.js";
import L500Firms from "./L500Firms.js";
import Firms from "./Firms.js";
import Feedback from "./Feedback.js";
import Research from "./Research.js";
import ResearchIndex from "./ResearchIndex.js";
import Editorial from "./Editorial.js";
import EditorialFirms from "./EditorialFirms.js";
import EditorialLawyers from "./EditorialLawyers.js";

import { trackPageView } from './analytics';

import 'bootstrap/dist/css/bootstrap.min.css';
import "./css/style.css";

function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
        // Track page view on route change
        const pageTitle = document.title;
        trackPageView(location.pathname, pageTitle);
    }, [location]);
}

export default function App() {
    return (
        <BrowserRouter>
            <AnalyticsTracker />
            <Routes>
                <Route path="/" element={<PageTemplate pageContent={<Home />} />} />
                <Route path="/about" element={<PageTemplate pageContent={<About />} />} />
                <Route path="/services" element={<PageTemplate pageContent={<Services />} />} />
                <Route path="/contact" element={<PageTemplate pageContent={<Contact />} />} />
                <Route path="/guides" element={<PageTemplate pageContent={<Guides />} />} />
                <Route path="/firms" element={<Firms />} />
                <Route path="/firms/:guideId" element={<Firms />} />
                <Route path="/lawyers" element={<Lawyers />} />
                <Route path="/lawyers/:guideId" element={<Lawyers />} />
                <Route path="/l500/firms" element={<L500Firms />} />
                <Route path="/l500/firms/:guideId" element={<L500Firms />} />
                <Route path="/l500/lawyers" element={<L500Lawyers />} />
                <Route path="/l500/lawyers/:guideId" element={<L500Lawyers />} />
                <Route path="/feedback" element={<PageTemplate pageContent={<Feedback />} />} />
                <Route path="/research" element={<PageTemplate pageContent={<ResearchIndex />} />} />
                <Route path="/research/:guideId/:year?" element={<Research />} />
                <Route path="/editorial" element={<Editorial />} />
                <Route path="/editorial/firms/:firmId" element={<EditorialFirms />} />
                <Route path="/editorial/lawyers/:lawyerId" element={<EditorialLawyers />} />
            </Routes>
        </BrowserRouter>
    );
}